<div class="header" [dir]="documentDir" [class.align-center]="vm.layout === 'Centered'" [class.align-right]="vm.layout === 'RightAligned'">
  <img
    *ngFor="let backgroundImage of backgroundImages; let index = index"
    osnSharedUseAsPicture
    class="header-background"
    [class.visible-image]="backgroundImagePosition === index"
    [src]="backgroundImage.fallbackUrl"
    [imgQuery]="backgroundImage.imgQuery"
    alt=""
  />
  <div class="content-container">
    <img class="osn-plus-logo align-self-center d-none d-sm-block" src="/assets/images/osn-logo.svg" alt="OSN+ logo" />
    <div class="email-collector-container">
      <h2 [class.light-text]="isLightText" class="welcome-title">
        {{ vm.title }}
      </h2>
      <osn-shared-email-collector
        [mlpStyle]="true"
        [inputPlaceholder]="vm.inputLabel"
        [buttonText]="vm.buttonText"
        [passwordPlaceholder]="'Email_Collector_password_placeholder' | translate"
        [emailCollectorPackageInformation]="vm.packageInformation"
        (loginError)="onLoginError()"
      ></osn-shared-email-collector>
    </div>
  </div>
</div>
